import React, { useEffect, useRef } from 'react';

export default function (WrappedComponent, selectData) {
	return (props) => {
		const placeholder = (props.placeholder !== undefined) ? props.intl.formatMessage({id:props.placeholder}) : "";
		const inputRef = useRef();

		useEffect(()=>{
			if(inputRef.current) {
				inputRef.current.onblur = onblur;
				inputRef.current.onfocus = onfocus;
			}

			return () => {
				if(inputRef.current) {
					inputRef.current.onblur = null;
					inputRef.current.onfocus = null;
				}
			}
		},[])

		const onfocus = (e) => {
			//If placeholder to text is enabled and the field is empty set the value
			if(e.target.value == "" && props.change !== undefined) {
				props.change(props.name, placeholder);
			}
		}

		const onblur = (e) => {
			//If placeholder to text is enabled and the field is empty set the value
			if(e.target.value == placeholder && props.change !== undefined) {
				props.change(props.name, "");
			}
		}

		const input_ref = (element) => {
			inputRef.current = element;
			if(props.inputRef !== undefined) props.inputRef(element);
		}
		
		return (
			<WrappedComponent {...props} inputRef={input_ref} />
		)
		
	};
}